import { createMuiTheme } from '@material-ui/core';
import { breakpoints } from './grid';
import { overrides } from './overrides';
import { palette } from './palette';
import { props } from './props';
import { spacing } from './spacing';
import { typography } from './typography';
/**
 * Custom theme configuration for AgentNet. To be extended by each brand where needed.
 *
 * @returns {Theme}
 */
export const theme = createMuiTheme({
    breakpoints,
    palette,
    props,
    overrides,
    spacing,
    typography,
});
